import React, { type ReactNode } from 'react';
import { cn } from '../../../utils';
import type { UIStyle } from '../../../types';
import { useUIStyle } from './use-ui-style';

export interface StyleContainerProps {
  /** UI style variant */
  uiStyle?: UIStyle;
  /** Children content */
  children: ReactNode;
  /** Additional class names */
  className?: string;
  /** HTML element to render as */
  as?: 'div' | 'section' | 'article';
}

/**
 * Container component that applies style-specific CSS classes and variables
 */
export function StyleContainer({
  uiStyle = 'default',
  children,
  className,
  as: Component = 'div',
}: StyleContainerProps) {
  const styleConfig = useUIStyle({ uiStyle });

  return (
    <Component
      className={cn(
        'qcall-widget-container',
        styleConfig.className,
        className
      )}
      data-qcall-style={uiStyle}
    >
      {children}
    </Component>
  );
}

export default StyleContainer;
